<template>
  <section class="has-background-grey pt-6 pb-8 px-5">
    <div class="container is-max-desktop padding-responsive">
      <div class="columns is-multiline">
        <div class="column is-full">
          <header class="my-4">
            <h3 class="titulo-bandera">Sucursales cercanas:</h3>
          </header>
        </div>

        <div v-for="(office, index) in officesWithDistance" :key="index" class="column is-6-tablet is-4-widescreen">
          <sucursal-card :office="office"></sucursal-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SucursalCard from './SucursalCard.vue'

export default {
  components: {
    SucursalCard,
  },
  props: {
    filteredOfficesRegion: {
      type: Array,
      required: true
    },
    selectedComuna: {
      type: String,
      required: true
    },
    comunas: {
      type: Array,
      required: true
    }
  },
  computed: {
    nonMunicipalOffices() {
      return this.filteredOfficesRegion.filter(office => !office.is_municipal);
    },
    referenciaComuna() {
      const comuna = this.comunas.find(comuna => comuna.value === this.selectedComuna);
      return comuna;
    },
    officesWithDistance() {
      if (!this.referenciaComuna) {
        return this.nonMunicipalOffices;
      }

      const officesWithDist = this.nonMunicipalOffices
        .map(office => {
          const distance = this.calculateDistance(
            this.referenciaComuna.lat,
            this.referenciaComuna.lng,
            office.lat,
            office.lng
          );

          return {
            ...office,
            distance: parseFloat(distance.toFixed(2))
          };
        })
        .sort((a, b) => a.distance - b.distance)
        .slice(0, 3);
        // console.log(officesWithDist);
      return officesWithDist;
    }
  },
  methods: {
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371;
      const toRadian = angle => (Math.PI / 180) * angle;

      const dLat = toRadian(lat2 - lat1);
      const dLon = toRadian(lon2 - lon1);

      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadian(lat1)) * Math.cos(toRadian(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;

      return distance;
    },
  },
}
</script>

<style scoped>
.debug-panel {
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>